import { message } from "antd";
import i18next from "i18next";
import instance from "../../store/actions/instance";

const t = i18next.t;

const getInvoiceBase64 = async (orderID, domain, type, params) => {
  const token = await getInvoiceToken();
  if (token) {
    try {
      const res = await instance.get(
        `https://${domain}/manage/invoice/${orderID}/print/${type}/base64/${token}/order/${params}`
      );
      return res.data;
    } catch {
      message.error(t("SomethingWentWrong"));
    }
  }
  return null;
};
const getInvoiceToken = async () => {
  try {
    const res = await instance.get(`/get_printable_token/`);
    if (res.data.success) {
      return res.data.token;
    } else {
      message.error(t("SomethingWentWrong"));
    }
  } catch (err) {
    console.error(err);
    if (err.response.status == 403) message.error(t("AccessDeniedMessage"));
  }
  return null;
};

async function getOrderSections(orderID) {
  try {
    const res = await instance.get(`get_order_sections/${orderID}`);
    return res.data;
  } catch {
    message.error(i18next.t("SomethingWentWrong"));
  }
}
export { getInvoiceBase64, getInvoiceToken, getOrderSections };
